var Timeslot = /** @class */ (function () {
    function Timeslot() {
        /**
         * Availabilities within this timeslot
         */
        this.gridAvailabilities = [];
        /**
         * Attendants within this timeslot
         */
        this.gridAttendants = [];
        /**
         * Assignments within this timeslot
         */
        this.gridAssignments = [];
        /**
         * Appointments within this timeslot
         */
        this.gridAppointments = [];
        /**
         * Absences within this timeslot
         */
        this.gridAbsences = [];
        /** Work patterns within this timeslot
         */
        this.gridWorkPatterns = [];
    }
    Object.defineProperty(Timeslot.prototype, "allObjects", {
        /**
         * All objects within this timeslot.
         *
         * @readonly
         * @type {any[]} all objects concattenated
         */
        get: function () {
            return this.gridAssignments
                .concat(this.gridAvailabilities)
                .concat(this.gridAppointments)
                .concat(this.gridAbsences)
                .concat(this.gridWorkPatterns);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clears the timeslot from all the objects
     */
    Timeslot.prototype.clear = function () {
        // this.gridAttendants.splice(0, this.gridAttendants.length);
        // this.gridAvailabilities.splice(0, this.gridAvailabilities.length);
        // this.gridAssignments.splice(0, this.gridAssignments.length);
        // this.gridAppointments.splice(0, this.gridAppointments.length);
        // this.gridAbsences.splice(0, this.gridAbsences.length);
        // this.gridWorkPatterns.splice(0, this.gridWorkPatterns.length);
        this.gridAttendants.length = 0;
        this.gridAvailabilities.length = 0;
        this.gridAssignments.length = 0;
        this.gridAppointments.length = 0;
        this.gridAbsences.length = 0;
        this.gridWorkPatterns.length = 0;
    };
    return Timeslot;
}());
export { Timeslot };
